import { render, staticRenderFns } from "./About.vue?vue&type=template&id=263eedd6&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=263eedd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263eedd6",
  null
  
)

export default component.exports